import { render } from "./MobileSearchForWordLanguage.component.vue?vue&type=template&id=170bb2ec"
import script from "./MobileSearchForWordLanguage.component.vue?vue&type=script&lang=js"
export * from "./MobileSearchForWordLanguage.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__